// SubjectList.js

import React from 'react';

const CombinatoricsSubjectList = () => {
  return (
    <div className="subject-list">
      {/* Your list of subjects */}
      <ul>
        <li className='subject-list-item' >Listing All Cases</li>
        <li className='subject-list-item'>the Multiplication Rule</li>
        <li className='subject-list-item'>n! i.e. Factorial</li>
        <li className='subject-list-item'>Permutations</li>
        <li className='subject-list-item'>Variations without Repetitions</li>
        <li className='subject-list-item'>Variations with Repetitions</li>
        <li className='subject-list-item'>Newton Symbol</li>
        <li className='subject-list-item'>Combinations</li>
      </ul>
    </div>
  );
};

export default CombinatoricsSubjectList;
